import { render, staticRenderFns } from "./ManageDivision.vue?vue&type=template&id=64350903&"
import script from "./ManageDivision.vue?vue&type=script&lang=js&"
export * from "./ManageDivision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports